import state from './moduleEventsState.js'
import mutations from './moduleEventsMutations.js'
import actions from './moduleEventsActions.js'
import getters from './moduleEventsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

